import { render, staticRenderFns } from "./busiDetail.vue?vue&type=template&id=5ebf45ac&"
import script from "./busiDetail.vue?vue&type=script&lang=js&"
export * from "./busiDetail.vue?vue&type=script&lang=js&"
import style0 from "./busiDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports